module.exports = __webpack_public_path__ + "static/media/crveni-logo.ba3269f0.png";